import API from "./api";

const TraductionArticleService = {
  getAll: async (articleId: number) => {
    const response = await API.get(
      `/articles/${articleId}/traductions`
    );
    return response.data.donnees;
  },

  getByLangue: async (
    articleId: number,
    langue: string
  ) => {
    const response = await API.get(
      `/articles/${articleId}/traductions/${langue}`
    );
    return response.data.donnees;
  },

  create: async (
    articleId: number,
    payload: any
  ) => {
    const response = await API.post(
      `/articles/${articleId}/traductions`,
      payload
    );
    return response.data.donnees;
  },

  update: async (id: number, payload: any) => {
    const response = await API.put(
      `/traductions-articles/${id}`,
      payload
    );
    return response.data.donnees;
  },

  delete: async (id: number) => {
    const response = await API.delete(
      `/traductions-articles/${id}`
    );
    return response.data.donnees;
  },
};

export default TraductionArticleService;